"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
const barcode_1 = require("client/components/barcode");
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const claim_1 = require("shared/claim");
require("./invoice.less");
const isPrinting = window.location.href.includes("print-labels");
let Invoice = class Invoice extends react_1.Component {
    constructor(props) {
        super(props);
        this.renderProviderInfo = (inventory, order, patient, provider, orderSite) => (React.createElement("tr", null,
            React.createElement("td", { className: "wide" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "wide top" },
                                React.createElement("span", { className: "uppercase" }, `${provider.firstName} ${provider.lastName} ${provider.title}`),
                                React.createElement("br", null),
                                orderSite.name,
                                React.createElement("br", null),
                                orderSite.address,
                                React.createElement("br", null),
                                `${orderSite.city}, ${orderSite.state} ${orderSite.zip}`,
                                React.createElement("br", null),
                                "Phone: ",
                                orderSite.phone),
                            React.createElement("td", null,
                                React.createElement("table", null,
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("th", { className: "left" }, "Date"),
                                            React.createElement("th", { className: "nowrap" }, "Order Number")),
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "left nowrap" }, moment(order.createDate).format("MM/DD/YYYY h:mm A")),
                                            React.createElement("td", { className: "right" }, order.id)),
                                        isPrinting && (React.createElement("tr", null,
                                            React.createElement("td", { colSpan: 2, className: "center" },
                                                patient.id,
                                                React.createElement("br", null),
                                                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 50, lineColor: "#26324e", value: inventory.barCode, margin: 0, width: 1 })))))))))))));
        this.renderBillingInfo = (patient) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("br", null),
                React.createElement("table", { className: "border wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: "shaded" },
                            React.createElement("th", { className: "half left" }, "Billing Info"),
                            React.createElement("th", { className: "half left" })),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", { className: "uppercase" }, `${patient.firstName} ${patient.lastName}`),
                                " ",
                                "\u00A0 (DOB: ",
                                moment(patient.birthDate).format("MM/DD/YYYY"),
                                ")",
                                React.createElement("br", null),
                                [patient.address, patient.address2].join(" ").trim(),
                                React.createElement("br", null),
                                React.createElement("span", { className: "uppercase" }, patient.city),
                                " ",
                                patient.state,
                                " ",
                                patient.zip,
                                React.createElement("br", null),
                                patient.phone),
                            React.createElement("td", null)))),
                React.createElement("br", null))));
        this.renderItem = (claims) => {
            const totalPriceInsurance = claims
                .reduce((a, c) => {
                var _a, _b;
                const price = Number((_b = (_a = c.copay) === null || _a === void 0 ? void 0 : _a.newPatientAmount) !== null && _b !== void 0 ? _b : c.patientAmount / 100) || 0;
                return a + price;
            }, 0)
                .toFixed(2);
            const totalPriceCash = claims
                .reduce((a, c) => {
                const price = Number(c.inventory.priceCash * c.quantity) || 0;
                return a + price;
            }, 0)
                .toFixed(2);
            const isInsurance = claims.find((claim) => claim.responses !== null);
            const totalPrice = isInsurance ? totalPriceInsurance : totalPriceCash;
            return (React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("table", { className: "border wide" },
                        React.createElement("tbody", null,
                            React.createElement("tr", { className: "shaded" },
                                React.createElement("th", { className: "left wide" }, "Item"),
                                React.createElement("th", null, "Qty"),
                                React.createElement("th", null),
                                React.createElement("th", { className: "right" }, "Amount")),
                            claims.map((claim, index) => {
                                var _a, _b;
                                const inventory = claim.inventory;
                                const insPrice = ((_b = (_a = claim.copay) === null || _a === void 0 ? void 0 : _a.newPatientAmount) !== null && _b !== void 0 ? _b : claim.patientAmount / 100).toFixed(2);
                                const cashPrice = (inventory.priceCash * claim.quantity).toFixed(2);
                                const price = isInsurance ? insPrice : cashPrice;
                                return (React.createElement("tr", { key: index },
                                    React.createElement("td", null,
                                        `${inventory.name} ${inventory.strength}${inventory.unit} ${inventory.dosage}`,
                                        React.createElement("br", null),
                                        "\u00A0\u00A0\u00A0\u00A0Rx #:",
                                        " ",
                                        claim.rxId && claim.rxId.rxId,
                                        " \u00A0NDC:",
                                        " ",
                                        inventory.package,
                                        " \u00A0"),
                                    React.createElement("td", { className: "right" }, claim.quantity),
                                    React.createElement("td", null),
                                    React.createElement("td", { className: "right" },
                                        "$",
                                        price)));
                            }),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 4, className: "border-bottom" })),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }),
                                React.createElement("td", { className: "nowrap right" }, "Subtotal: "),
                                React.createElement("td", { className: "nowrap right" },
                                    "$",
                                    totalPrice)),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }),
                                React.createElement("td", { className: "nowrap right" }, "Tax:"),
                                React.createElement("td", { className: "nowrap right" }, "$0.00")),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }),
                                React.createElement("td", { className: "nowrap right" }, "Total:"),
                                React.createElement("td", { className: "nowrap right" },
                                    "$",
                                    totalPrice)),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }),
                                React.createElement("td", { className: "nowrap right" }, "Payment:"),
                                React.createElement("td", { className: "nowrap right" }, "$0.00")),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }),
                                React.createElement("td", { className: "nowrap right" }, "Balance Due:"),
                                React.createElement("td", { className: "nowrap right" },
                                    "$",
                                    totalPrice)))))));
        };
        this.renderPatientAcknowledgement = (claim) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("br", null),
                React.createElement("table", { className: "border wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: "shaded" },
                            React.createElement("th", { className: "left wide" }, "Patient Acknowledgement")),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                "By signing, patient acknowledges receipt of and instruction on the use and contraindications of the product(s) listed above. If payment has been made by credit card, patient agrees to pay the above amount according to the card issuer agreement. Patient acknowledges medications may not be returned and that all sales are final.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("br", null))))))));
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        const patient = claim && claim.order.patient;
        const provider = claim && claim.order.provider;
        const orderSite = claim && claim.order.site;
        const status = claim_1.ClaimStatus.Paid;
        // We might want to update this to be only selectedClaims just in case
        // the provider wants to not dispense a paid claim in the last second.
        const claims = store_1.ordersStore.selectedClaims ||
            (store_1.ordersStore.claimsGroup.value &&
                store_1.ordersStore.claimsGroup.value
                    .reduce((a, c) => a.concat(...c.children), [])
                    .map(item => {
                    const arry = [];
                    // while (arry.length < item.quantity) {
                    arry.push(item);
                    // }
                    return arry;
                })
                    .reduce((a, c) => a.concat(...c), [])
                    .filter(claim => claim.status === status));
        return (React.createElement("div", { className: "invoice" },
            React.createElement("table", { className: "invoice__table" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { className: "invoice__title wide" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { className: "large" }, "Invoice")))))),
                    claim &&
                        claim.order &&
                        inventory &&
                        patient &&
                        provider &&
                        orderSite &&
                        this.renderProviderInfo(inventory, claim.order, patient, provider, orderSite),
                    patient && this.renderBillingInfo(patient),
                    claims && this.renderItem(claims),
                    claim && this.renderPatientAcknowledgement(claim)))));
    }
};
Invoice = __decorate([
    mobx_react_1.observer
], Invoice);
exports.Invoice = Invoice;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/invoice/invoice.tsx
// module id = 2983
// module chunks = 0 1